import {BufferWriter, Writer} from "protobufjs";
import {IApiClient} from "../client";
import {api} from "../rpc/api";
import {getToken} from "./bind_token";

export class PartnerStoreEntryAPI {
    constructor(readonly apiClient: IApiClient) {
    }

    public create = (
        params: api.ICreatePartnerStoreEntryRequest
    ): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            getToken()
                .then((token: string): Promise<Uint8Array> => {
                    const writer: BufferWriter | Writer = Writer.create();
                    return this.apiClient.postWithToken(
                        "/api.PartnerStoreEntryService/Create",
                        token,
                        api.CreatePartnerStoreEntryRequest.encode(params, writer).finish()
                    );
                })
                .then((binary: Uint8Array): void => {
                    resolve();
                })
                .catch((error: Error): void => {
                    reject(error);
                });
        });
    };
}



// WEBPACK FOOTER //
// ./src/infra/api/service/partner_store_entry_api.ts